module.exports = __webpack_public_path__ + "static/img/COC2021-20.d6a43eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-20.jpg
// module id = r+DJ
// module chunks = 0